import https from '@sg/utils/httpC';

export type TAdPlacementType = 'marquee' | 'newicon' | string;

export interface IAdPlacementContent {
  text?: string;
  text_cn?: string;
  text_en?: string;
  link?: string;
  bg_color?: string;
  text_color?: string;
  speed?: 'slow' | 'normal' | 'fast' | string;
  closeable?: boolean;
  [key: string]: any;
}

export interface IAdPlacementItem {
  id: number;
  base_url: string;
  type: TAdPlacementType;
  content: IAdPlacementContent;
  start_time?: string;
  end_time?: string;
}

export interface IFetchAdPlacementsParams {
  baseUrl: string;
  type?: TAdPlacementType;
}

export const fetchAdPlacements = async (
  params: IFetchAdPlacementsParams,
): Promise<IAdPlacementItem[]> => {
  try {
    const response: any = await https({
      url: '/api/v1/mgmt_pc/ad',
      method: 'post',
      data: {
        base_url: params.baseUrl,
        ...(params.type ? { type: params.type } : {}),
      },
      rawData: true,
    });

    const candidateData =
      (Array.isArray(response?.data) && response?.data)
      || (Array.isArray(response?.data?.data) && response?.data?.data)
      || (Array.isArray(response?.result?.data) && response?.result?.data)
      || [];

    return candidateData
      .filter((item: any) => item && typeof item === 'object')
      .map((item: any) => ({
        id: Number(item?.id || 0),
        base_url: String(item?.base_url || ''),
        type: String(item?.type || ''),
        content:
          item?.content && typeof item.content === 'object'
            ? item.content
            : {},
        start_time: item?.start_time,
        end_time: item?.end_time,
      }));
  } catch (error) {
    console.error('[AlertTip] Failed to fetch ad placements:', error);
    return [];
  }
};

export const getCurrentDomain = (): string => window.location.origin;
